import React from "react";

// eslint-disable-next-line react/prop-types
function PlusIcon({ width = 18, height = 18 }) {
  return (
    <svg width={width} height={height} fill="none">
      <circle cx="9" cy="9" r="9" fill="#0000FF" />
      <path
        d="M14 8.66667H10V4.66667C10 4.48986 9.92976 4.32029 9.80474 4.19526C9.67971 4.07024 9.51014 4 9.33333 4C9.15652 4 8.98695 4.07024 8.86193 4.19526C8.7369 4.32029 8.66667 4.48986 8.66667 4.66667V8.66667H4.66667C4.48986 8.66667 4.32029 8.7369 4.19526 8.86193C4.07024 8.98695 4 9.15652 4 9.33333C4 9.51014 4.07024 9.67971 4.19526 9.80474C4.32029 9.92976 4.48986 10 4.66667 10H8.66667V14C8.66667 14.1768 8.7369 14.3464 8.86193 14.4714C8.98695 14.5964 9.15652 14.6667 9.33333 14.6667C9.51014 14.6667 9.67971 14.5964 9.80474 14.4714C9.92976 14.3464 10 14.1768 10 14V10H14C14.1768 10 14.3464 9.92976 14.4714 9.80474C14.5964 9.67971 14.6667 9.51014 14.6667 9.33333C14.6667 9.15652 14.5964 8.98695 14.4714 8.86193C14.3464 8.7369 14.1768 8.66667 14 8.66667Z"
        fill="white"
      />
    </svg>
  );
}

export default PlusIcon;
